import { NumberValue } from '../../../utils'

export const getAmountIncludingVat = (amountExcludingVat: number, vatRatePercent?: number) => {
  if (!vatRatePercent) {
    return amountExcludingVat
  }

  return new NumberValue(amountExcludingVat).multiply(1 + vatRatePercent).getRounded()
}
